import { IOrderItem } from '../model/IOrder'

export function getVendorListFromOrderItems(orderItems: IOrderItem[]) {
  return Array.from(
    new Set(
      orderItems.reduce(
        (acc, { vendor }) => [...acc, ...(vendor?.name ? [vendor.name] : [])],
        [] as string[],
      ),
    ),
  ).join(', ')
}
